import { Injectable } from '@angular/core';
import { OpenAPI } from '../../../gen/syncui';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private configService: ConfigService) {}

  async initializeApp(): Promise<void> {
    return new Promise(async (resolve) => {
      // Wait for runtime configuration to load
      await this.configService.loadRuntimeConfig();
      
      // Set the OpenAPI base URL based on configuration (runtime or build-time)
      const apiConfig = this.configService.getApiConfig();
      OpenAPI.BASE = apiConfig.baseUrl;

      // Configure the OpenAPI token to use the securly_token from localStorage
      OpenAPI.TOKEN = () => Promise.resolve(localStorage.getItem('securly_token') || '');

      if (this.configService.isDebugLoggingEnabled()) {
        console.log('App initialized with API base URL:', apiConfig.baseUrl);
        console.log('Configuration:', this.configService.getConfig());
      }

      resolve();
    });
  }
}
